import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IdleService } from './idle.service';

@Injectable({ providedIn: 'root' })
export class IdleDistributedService extends IdleService implements OnDestroy {
  private remoteTimeout: number;
  private localTimeout: number;
  private subscription: Subscription = new Subscription();
  private isIdleState: boolean;

  override init(idleFrameSeconds: number) {
    this.setListeners();
    this.subscription = this.idle$.subscribe(isIdle => (this.isIdleState = isIdle));
    super.init(idleFrameSeconds);
  }

  override restart() {
    super.restart();
    this.pullRemoteTimeout();
    this.syncTimeouts();
  }

  override setTimeout(newTimeout: number): number {
    this.localTimeout = super.setTimeout(newTimeout);
    if (this.localTimeout > this.remoteTimeout) {
      this.pushRemoteTimeout(this.localTimeout);
    }
    return this.localTimeout;
  }

  protected override checkIdle() {
    if (this.isExpired(this.localTimeout)) {
      this.pullRemoteTimeout();
      if (this.isExpired(this.remoteTimeout)) {
        this.openAlert();
      } else {
        this.setTimeout(this.remoteTimeout);
      }
    }
  }

  private pullRemoteTimeout() {
    const stored = localStorage.getItem('idleTimeout');
    this.remoteTimeout = stored ? Number.parseInt(stored) : 0;
  }

  private pushRemoteTimeout(value) {
    this.remoteTimeout = value;
    localStorage.setItem('idleTimeout', this.remoteTimeout.toString());
  }

  private syncTimeouts() {
    if (this.remoteTimeout > this.localTimeout) {
      this.setTimeout(this.remoteTimeout);
    } else if (this.remoteTimeout < this.localTimeout) {
      this.pushRemoteTimeout(this.localTimeout);
    }
  }

  private setListeners() {
    window.addEventListener('storage', e => this.storageEventHandler(e));
  }

  private removeListeners() {
    window.removeEventListener('storage', e => this.storageEventHandler(e));
  }

  private storageEventHandler(e) {
    if (e.key === 'idleTimeout') {
      this.remoteTimeout = e.newValue;
      if (this.isIdleState && this.remoteTimeout > this.localTimeout) {
        this.restart();
      } else {
        this.syncTimeouts();
      }
    }
  }

  override ngOnDestroy() {
    this.removeListeners();
    this.subscription.unsubscribe();
  }
}
